import type { PatientPharmacyT, PharmacyT } from '@lotushealth/lotushealth_js_sdk/schemas';

import type { RxPharmacy } from './types';

export function patientPharmacyToRxPharmacy(pharmacy: PatientPharmacyT): RxPharmacy | null {
  const pharmacyId = pharmacy.PharmacyId;
  if (pharmacyId == null || !Number.isFinite(pharmacyId)) {
    return null;
  }

  return {
    Address1: pharmacy.Address1 ?? null,
    Address2: pharmacy.Address2 ?? null,
    City: pharmacy.City ?? null,
    Latitude: pharmacy.Latitude ?? null,
    Longitude: pharmacy.Longitude ?? null,
    NCPDPID: pharmacy.NCPDPID ?? null,
    PharmacyId: pharmacyId,
    PharmacySpecialties: pharmacy.PharmacySpecialties ?? null,
    PhoneAdditional1: pharmacy.PhoneAdditional1 ?? null,
    PhoneAdditional2: pharmacy.PhoneAdditional2 ?? null,
    PhoneAdditional3: pharmacy.PhoneAdditional3 ?? null,
    PhoneAdditionalType1: pharmacy.PhoneAdditionalType1 ?? null,
    PhoneAdditionalType2: pharmacy.PhoneAdditionalType2 ?? null,
    PhoneAdditionalType3: pharmacy.PhoneAdditionalType3 ?? null,
    PrimaryFax: pharmacy.PrimaryFax ?? null,
    PrimaryPhone: pharmacy.PrimaryPhone ?? null,
    PrimaryPhoneType: pharmacy.PrimaryPhoneType ?? null,
    ServiceLevel: pharmacy.ServiceLevel ?? null,
    State: pharmacy.State ?? null,
    StoreName: pharmacy.StoreName ?? null,
    ZipCode: pharmacy.ZipCode ?? null,
  };
}

export function pharmacyToRxPharmacy(pharmacy: PharmacyT): RxPharmacy | null {
  const pharmacyId = pharmacy.PharmacyId;
  if (pharmacyId == null || !Number.isFinite(pharmacyId)) {
    return null;
  }

  return {
    Address1: pharmacy.Address1 ?? null,
    Address2: pharmacy.Address2 ?? null,
    City: pharmacy.City ?? null,
    Latitude: pharmacy.Latitude ?? null,
    Longitude: pharmacy.Longitude ?? null,
    NCPDPID: pharmacy.NCPDPID ?? null,
    PharmacyId: pharmacyId,
    PharmacySpecialties: pharmacy.PharmacySpecialties ?? null,
    PhoneAdditional1: pharmacy.PhoneAdditional1 ?? null,
    PhoneAdditional2: pharmacy.PhoneAdditional2 ?? null,
    PhoneAdditional3: pharmacy.PhoneAdditional3 ?? null,
    PhoneAdditionalType1: pharmacy.PhoneAdditionalType1 ?? null,
    PhoneAdditionalType2: pharmacy.PhoneAdditionalType2 ?? null,
    PhoneAdditionalType3: pharmacy.PhoneAdditionalType3 ?? null,
    PrimaryFax: pharmacy.PrimaryFax ?? null,
    PrimaryPhone: pharmacy.PrimaryPhone ?? null,
    PrimaryPhoneType: pharmacy.PrimaryPhoneType ?? null,
    ServiceLevel: pharmacy.ServiceLevel ?? null,
    State: pharmacy.State ?? null,
    StoreName: pharmacy.StoreName ?? null,
    ZipCode: pharmacy.ZipCode ?? null,
  };
}
